import { useReduxState } from 'hooks';

interface Props {
  negative: number;
  neutral: number;
  positive: number;
}

const ConversationAnalysisSentimentLabels = ({
  negative,
  neutral,
  positive
}: Props) => {
  const { messages, theme } = useReduxState();

  return (
    <div className="labels">
      <div className="label">
        <div className="dot" style={{ backgroundColor: theme.successColor }} />
        {`${messages.commonPositive} ${positive}%`}
      </div>

      <div className="label">
        <div
          className="dot"
          style={{ backgroundColor: 'rgba(0, 0, 0, 0.4)' }}
        />
        {`${messages.commonNeutral} ${neutral}%`}
      </div>

      <div className="label">
        <div className="dot" style={{ backgroundColor: theme.dangerColor }} />
        {`${messages.commonNegative} ${negative}%`}
      </div>

      <style jsx>{`
        .labels {
          align-items: center;
          display: flex;
          flex-wrap: wrap;
          gap: 0px 40px;
        }
        .label {
          align-items: center;
          color: ${theme.textColorLighter};
          display: flex;
          font-size: 1.4rem;
          font-weight: 600;
          gap: 5px;
        }
        .dot {
          border-radius: 20px;
          height: 10px;
          width: 10px;
        }
      `}</style>
    </div>
  );
};

export default ConversationAnalysisSentimentLabels;
